import style from 'styled-components';

export const StyledCancelModal = style.div`
`;
